module.exports = __webpack_public_path__ + "61f78ccf93f819efcbf83b8de614a25c.svg";